<script setup>

const { locale } = useI18n()
const route = useRoute()

const discs = ref(null)
const selectedTrack = ref(null)

const props = defineProps({
	tracklistId: {
		type: String
	},
	albumUrl: {
		type: String
	},
	format: {
		type: String
	}
})

const selectTrack = (track) => {
	console.log(track)
	selectedTrack.value = track
}

function trackNumber(indexDisc, indexSong, indexTrack) {
	const songs = discs.value[indexDisc].songs;
	let count = 0; // počet tracků ve všech předchozích songs v rámci procházeného disku

	for (let i = 0; i < indexSong; i++) {
		count += songs[i].tracks.length;
	}

	return count + indexTrack + 1;
}

function parseMultiFormat(formatRaw) {
  const s = String(formatRaw ?? "").toUpperCase()

  const re = /([2-8])\s*(?:X|×)?\s*(LP|CD|DVD)\b/
  const m = s.match(re)

  if (!m) return null
  const count = Number(m[1])
  const label = m[2]

  if (!Number.isFinite(count) || count < 2) return null
  return { label, count }
}

const multiFormat = computed(() => parseMultiFormat(props.format))

const discHeading = (indexDisc) => {
  if (!multiFormat.value) return null
  return `${multiFormat.value.label} ${indexDisc + 1}`
}

onMounted(async () => {
	const result = await useUIFetch(locale.value, `Album/${route.params.slug}/component/${props.tracklistId}?tracklist=1`)

	if(result) {


		discs.value = result.discs
	}
})


</script>

<template>
	<div>
		<div v-if="discs">
			<div v-for="(list, indexDisc) in discs" :key="indexDisc">
				<h4
          v-if="discHeading(indexDisc)"
          class="dark:text-light text-dark mb-5 mt-8"
        >
          {{ discHeading(indexDisc) }}
        </h4>
				<div v-for="(song, indexSong) in list.songs" :key="indexSong">
					<h4 v-if="song.name" class="dark:text-light text-dark mb-5 mt-8">
						{{ song.name }}
					</h4>
					<div v-for="(track, indexTrack) in song.tracks" :key="indexTrack">
						<AlbumTrack
							@click="selectTrack(track)"
							:index-track="trackNumber(indexDisc, indexSong, indexTrack)"
							:track="track"
							:active="selectedTrack?.supraphonlineId === track.supraphonlineId"
						/>
					</div>
				</div>
			</div>
			<Button :to="albumUrl" target class="mt-7">{{ $t('album.buy') }}</Button>
		</div>
		<div v-else>
			<Loader />
		</div>
	</div>
</template>